import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useCommonParams from "../../../hooks/useCommonParams";
import { getAnalyticsAction } from "../../../redux/actions/analytics";

export default function useGetAnalyticsQuery() {
  const dispatch = useDispatch();

  const { analyticsData, loading, totalRecords } = useSelector(
    (state) => state.analytics
  );

  const { queryParams } = useCommonParams();

  useEffect(() => {
    dispatch(getAnalyticsAction(queryParams));
  }, [queryParams]);

  return {
    analyticsData,
    totalAnalyticsRecords: totalRecords,
    analyticsLoading: loading,
  };
}
